import { styled } from '@mui/material';

export const Asterisk = styled(({ className }: { className?: string }) => (
    <span className={className}>*</span>
))(({ theme }) => ({ color: theme.palette.text.secondary }));
